import React from "react";
import "./biller-icon.css";

function BillerIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.292"
        height="21.449"
        viewBox="0 0 23.292 21.449"
      >
        <defs></defs>
        <g transform="translate(1 1)">
          <path
            className="biller-icon"
            d="M110.774,114.02V116.2a3.051,3.051,0,0,1-3.044,3.039h-13.4A3.051,3.051,0,0,1,91.29,116.2l3.431-.1V102.829a3.051,3.051,0,0,1,3.044-3.039h9.964a3.051,3.051,0,0,1,3.044,3.039v.931"
            transform="translate(-91.29 -99.79)"
          />
          <line
            className="biller-icon"
            x2="14.267"
            transform="translate(8.024 5.657)"
          />
          <line
            className="biller-icon"
            x2="14.267"
            transform="translate(8.024 9.266)"
          />
          <line
            className="biller-icon"
            x2="14.267"
            transform="translate(8.024 12.862)"
          />
        </g>
      </svg>
    </>
  );
}

export default BillerIcon;
